import { ContainerContentSearchPage } from "@/features/delivery-order-batch/pages/ContainerContentSearchPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/outbound-container/scan")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({ permissions: ["container.view"] })
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: ContainerContentSearchPage,
});
